
function setBgImage() {
  //console.log('set bg image');

  var clBg = document.querySelectorAll('.cld-bg');
	clBg.forEach(el => {
		//console.log('el', el);

    var elements = el.dataset.class ? document.querySelectorAll('.' + el.dataset.class) : [el.parentNode];
		elements.forEach(item => {
			//console.log('item', item);

      if (el.dataset.size) {
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        //console.log('vw', vw);

        if (vw <= el.dataset.size) {
          item.style.backgroundImage = "url('"+el.src+"')";
        }
      }
      else {
        item.style.backgroundImage = "url('"+el.src+"')";
      }

		});
	});
}


export default function cloudImages() {

  var cl = cloudinary.Cloudinary.new({cloud_name: "dmh15ov9z"});
  cl.responsive();

	setBgImage();

  window.addEventListener('resize', _.debounce(() => {
    setBgImage();
  }, 400));
}
